import React from 'react';
import './reviewRating.css';

export class ReviewRating extends React.Component {
    getRatingColor(rating) {
        switch (rating) {
            case 9:
            case 10:
                return 'bg-dark-green';
            case 7:
            case 8:
                return 'bg-light-green';
            case 5:
            case 6:
                return 'bg-yellow';
            case 3:
            case 4:
                return 'bg-orange';
            case 0:
            case 1:
            case 2:
                return 'bg-red';
            default:
                return '';
        }
    }

    getRatingSize(size) {
        switch (size) {
            case 'x-small':
                return 'review-rating-x-small';
            case 'small':
                return 'review-rating-small';
            case 'medium':
                return 'review-rating-x-small';
            case 'large':
                return 'review-rating-x-small';
            default:
                return '';
        }
    }

    render() {
        return (
            <span>
                <div className={`${this.getRatingColor(this.props.rating)} ${this.getRatingSize(this.props.size)}`} >{this.props.rating}</div>
            </span>
        );
    }
}